import { render } from "./review-submitted-notification.vue?vue&type=template&id=2243739f&ts=true"
import script from "./review-submitted-notification.ts?vue&type=script&lang=ts&external"
export * from "./review-submitted-notification.ts?vue&type=script&lang=ts&external"

import "./review-submitted-notification.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__